<template>
    <div class="detailsUserAdminCompany">
        <div v-if="loading" class="text-center">
            <v-progress-circular class="mt-auto" :size="70" :width="7" color="primary"
                indeterminate></v-progress-circular>
        </div>

        <div v-else class="col-md-12">
            <v-form ref="form" lazy-validation class="col-sm-12 col-md-12">
                <div class="custom-row">
                    <div class="col-sm-12 col-md-5">
                        <v-text-field color="secondary" label="*Empresa" placeholder="Selecciona una Empresa" disabled
                            v-model="formData.companyName"></v-text-field>

                        <v-text-field color=secondary label="*Primer Nombre" placeholder="Ingrese el primer nombre"
                            required :counter="50" :maxlength="50" :rules="firstNameRules"
                            v-model="formData.firstName"></v-text-field>

                        <v-text-field color=secondary label="*Primer Apellido" placeholder="Ingrese el primer apellido"
                            required :counter="50" :maxlength="50" :rules="lastNameRules"
                            v-model="formData.lastName"></v-text-field>

                        <v-select color="secondary" label="*Tipo Identificación"
                            placeholder="Selecciona un tipo de identificación" required :items="typeIdentification"
                            item-text="identificationType" item-value="identificationId"
                            :rules="tipoIdentificacionRules" v-model="formData.identificationId"></v-select>

                        <v-select color="secondary" label="*Rol" placeholder="Selecciona un tipo del rol" required
                            :items="typeRol" item-text="nameRole" item-value="roleId" disabled :rules="tipoRolRules"
                            v-model="formData.roleId"></v-select>

                        <v-select color="secondary" label="*Género" placeholder="Selecciona un tipo de género" required
                            :items="affiliatedGender" item-text="gernderName" item-value="genderId" :rules="genderRules"
                            v-model="formData.genderId"></v-select>
                    </div>
                    <div class="col-sm-12 col-md-5">

                        <v-text-field color=secondary label="*Correo" placeholder="Ingrese un Correo" required
                            :counter="200" :maxlength="200" v-model="formData.emailAddress"
                            :rules="emailRules"></v-text-field>

                        <v-text-field color=secondary label="Segundo Nombre" placeholder="Ingrese el segundo nombre"
                            :counter="50" :maxlength="50" v-model="formData.middleName"></v-text-field>

                        <v-text-field color=secondary label="Segundo Apellido" placeholder="Ingrese el segundo apellido"
                            :counter="50" :maxlength="50" v-model="formData.secondLastName"></v-text-field>

                        <v-text-field color="secondary" label="*Número Identificación"
                            placeholder="Ingrese el Número Identificación" required
                            :rules="[...idNumberRules, idNumberLengthRule]" @input="formatIdentificationNumber"
                            v-model="formData.identificationNumber" @keydown="handleKeyDown" inputmode="numeric"
                            pattern="[0-9]{19}" :counter="19" :maxlength="19"></v-text-field>

                        <v-row>
                            <v-col cols="4" md="3" sm="3">
                                <v-select color="secondary" label="*Indicativo" required :items="listGender"
                                    item-text="countryPhoneCode" item-value="countryPhoneCodeId"
                                    v-model="formData.countryPhoneCodeId" :rules="CountryPhoneCodeRules">
                                </v-select>
                            </v-col>

                            <v-col cols="8" md="9" sm="9">
                                <v-text-field color="secondary" label="*Contacto WhatsApp"
                                    placeholder="Ingrese el Contacto WhatsApp" required
                                    :rules="[...idNumberCRules, idNumberCLengthRule]" v-model="formData.cellPhoneNumber"
                                    @keydown="handleKeyDown" inputmode="numeric" pattern="[0-9]{10}" :counter="10"
                                    :maxlength="10">
                                </v-text-field>
                            </v-col>
                        </v-row>

                    </div>
                </div>
            </v-form>

        </div>


        <div style="position: relative;">
            <v-tooltip left style="position: absolute;">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn fab fixed bottom right dark large color="primary" v-bind="attrs" v-on="on"
                        @click="submitForm">
                        <v-icon dark>mdi-content-save</v-icon>
                    </v-btn>
                </template>
                <span>Actualizar usuario</span>
            </v-tooltip>

            <v-tooltip left style="position: absolute;">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn fab fixed bottom right dark large color="primary" v-bind="attrs" v-on="on"
                        @click="deleteUserAdmin(formData.userId)" style="margin-bottom: 80px;">
                        <v-icon dark>mdi-delete</v-icon>
                    </v-btn>
                </template>
                <span>Eliminar usuario</span>
            </v-tooltip>

            <detailsChangeStateUser :isBlocked="userAdminId?.isBlocked ?? false" :isActivo="true"
                :userStatus="userAdminId?.userState.stateId" :text="userAdminId?.reasonBlock"
                :userId="userAdminId?.userId" :blockedByUser="userAdminId?.blockedByUser" />
        </div>
    </div>
</template>

<script>

import { mapActions, mapGetters } from "vuex";

import {
    USERSADMIN_M,
    ACTION_PUT_UPDATE_USERSADMIN_COMPANY_ID,
    ACTION_GET_USERSADMIN_LIST_TYPE_DOCUMENT,
    GET_USERADMIN_LIST_TYPE_DOCUMENT,
    GET_STATE_LOADING,
    ACTION_GET_USERSADMIN_COMPANY_ID,
    GET_USER_ADMIN_COMPANY_ID,
    ACTION_DELETE_USERSADMIN,
    GET_USERADMIN_LIST_TYPE_ROL,
    ACTION_GET_USERSADMIN_LIST_TYPE_ROL,
    ACTION_GET_AFFILIATEDUSERS_LIST_GENDER,
    GET_AFFILIATEDUSERS_LIST_GENDER,
} from "@/views/users_admin/store/types/types.js";

import {
    PRODUCTS_M,
    ACTION_GET_LIST_COUNTRY,
    GET_LIST_COUNTRY
} from "@/views/products/store/types/types.js";

import Swal from "sweetalert2";
import EventBus from '@/utils/event_bus.js';
import detailsChangeStateUser from "@/shared/components/detail_change_state_user/detail_change_state_user_page.vue";

const correoRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export default {
    props: {
        usersAdminIdCompany: {
            required: true
        },
        companyId: {
            required: true
        }
    },

    components: {
        detailsChangeStateUser
    },
    name: "detailsUserAdminCompany",

    data() {
        return {

            formData: {
                firstName: '',
                userId: '',
                middleName: '',
                lastName: '',
                secondLastName: '',
                companyId: '',
                companyName: '',
                identificationType: '',
                emailAddress: '',
                isFirstUserCompany: true,
                identificationId: '',
                identificationNumber: '',
                roleId: '',
                nameRole: '',
                genderId: '',
                gernderName: '',
                cellPhoneNumber: '',
                countryPhoneCodeId: '',
                userDetailId: '',
                stateId: '',
                isBlocked: '',
                reasonBlock: '',
                blockedByUser: ''
            },
            firstNameRules: [
                v => !!v || "Primer Nombre requerido",
                v => (v && v.length <= 50) || "El primer nombre no puede tener más de 50 caracteres"
            ],

            lastNameRules: [
                v => !!v || "El primer apellido requerido",
                v => (v && v.length <= 50) || "El primer apellido no puede tener más de 50 caracteres"
            ],

            tipoIdentificacionRules: [
                v => !!v || "Tipo identificación requerido"
            ],

            idNumberRules: [
                v => !!v || "El número identificación requerido",
            ],
            idNumberLengthRule: v =>
                (v && v.length <= 19) || "El número de identificación debe tener 19 dígitos",

            CountryPhoneCodeRules: [
                v => !!v || "El indicativo es requerido"
            ],
            emailRules: [
                v => !!v || "El correo requerido",
                v => (v && v.length <= 200) || "El correo no puede tener más de 200 caracteres",
                v => correoRegex.test(v) || "El formato del correo es inválido"
            ],
            tipoRolRules: [
                v => !!v || "Rol requerido"
            ],

            genderRules: [
                v => !!v || "El género requerido"
            ],

            idNumberCRules: [
                v => !!v || "El contacto WhatsApp es requerido",
            ],

            idNumberCLengthRule: v =>
                (v.length === 10) || "El contacto WhatsApp debe tener 10 dígitos",

            CountrycellPhoneNumberCodeRules: [
                v => !!v || "El indicativo es requerido"
            ],

            showErrorMessages: false,
            usersAdminIdUpdate: null,
        };
    },
    watch: {
        userAdminId: {
            immediate: true,
            handler(newValue) {
                if (newValue) {
                    this.formData.firstName = newValue.firstName;
                    this.formData.userId = newValue.userId;
                    this.formData.companyName = newValue.companyName;
                    this.formData.companyId = newValue.companyId;
                    this.formData.middleName = newValue.middleName;
                    this.formData.lastName = newValue.lastName;
                    this.formData.isFirstUserCompany = true;
                    this.formData.secondLastName = newValue.secondLastName;
                    this.formData.identificationType = newValue.identification.identificationType;
                    this.formData.emailAddress = newValue.emailAddress;
                    this.formData.genderId = newValue.userDetailResponse.gender.genderId;
                    this.formData.gernderName = newValue.userDetailResponse.gender.gernderName;
                    this.formData.identificationId = newValue.identification.identificationId;
                    this.formData.identificationNumber = newValue.identificationNumber;
                    this.formData.roleId = newValue.role.roleId;
                    this.formData.nameRole = newValue.role.nameRole;
                    this.formData.cellPhoneNumber = newValue?.userDetailResponse?.cellPhoneNumber;
                    this.formData.countryPhoneCodeId = newValue?.userDetailResponse.countryPhoneCode?.countryPhoneCodeId || null;
                    this.formData.userDetailId = newValue?.userDetailResponse?.userDetailId;
                    this.formData.stateId = newValue?.userState?.stateId;
                    this.formData.isBlocked = newValue?.isBlocked;
                    this.formData.reasonBlock = newValue?.reasonBlock;
                    this.formData.blockedByUser = newValue?.blockedByUser;
                }
            }
        }
    },

    async mounted() {
        await this.getActionuserAdminComanyId(this.companyId);
        await this.getActionTypeIdentification();
        await this.getActionTypeRol();
        this.getActionListCountry();
        this.getAffiliatedGender();

        EventBus.$on('reload-delete-userAdmin', async () => {
            await this.reloadUserAdmin();
        });
    },
    computed: {

        ...mapGetters({
            loading: [`${USERSADMIN_M}${GET_STATE_LOADING}`],
            typeIdentification: [`${USERSADMIN_M}${GET_USERADMIN_LIST_TYPE_DOCUMENT}`],
            userAdminId: [`${USERSADMIN_M}${GET_USER_ADMIN_COMPANY_ID}`],
            typeRol: [`${USERSADMIN_M}${GET_USERADMIN_LIST_TYPE_ROL}`],
            affiliatedGender: [`${USERSADMIN_M}${GET_AFFILIATEDUSERS_LIST_GENDER}`],
            listGender: [`${PRODUCTS_M}${GET_LIST_COUNTRY}`],
        }),

    },

    methods: {

        ...mapActions({
            upDateUserAdminCompanyId: `${USERSADMIN_M}${ACTION_PUT_UPDATE_USERSADMIN_COMPANY_ID}`,
            getActionTypeIdentification: `${USERSADMIN_M}${ACTION_GET_USERSADMIN_LIST_TYPE_DOCUMENT}`,
            getActionuserAdminComanyId: `${USERSADMIN_M}${ACTION_GET_USERSADMIN_COMPANY_ID}`,
            deleteActionUserAdmin: `${USERSADMIN_M}${ACTION_DELETE_USERSADMIN}`,
            getActionTypeRol: `${USERSADMIN_M}${ACTION_GET_USERSADMIN_LIST_TYPE_ROL}`,
            getActionListCountry: `${PRODUCTS_M}${ACTION_GET_LIST_COUNTRY}`,
            getAffiliatedGender: `${USERSADMIN_M}${ACTION_GET_AFFILIATEDUSERS_LIST_GENDER}`,
        }),

        async reloadUserAdmin() {
            await this.getActionuserAdminComanyId(this.formData.userId);
        },

        handleKeyDown(event) {
            // Permite solo números y la tecla de borrar
            if (!/^[0-9]$/.test(event.key) && event.key !== 'Backspace') {
                event.preventDefault();
            }
        },


        async deleteUserAdmin(userId) {
            const result = await Swal.fire({
                title: '¿Estás seguro?',
                text: 'Esta acción no se puede deshacer.',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: '#6E17A5'
            });

            if (result.isConfirmed) {

                this.deleteActionUserAdmin(userId);
                this.reloadUserAdmin();

            } else {
                Swal.fire({
                    position: 'top-end',
                    icon: 'info',
                    title: 'La acción ha sido cancelada.',
                    showConfirmButton: false,
                    timer: 2500
                });
            }
        },

        async submitForm() {
            try {

                const result = await Swal.fire({
                    title: '¿Desea Guardar?',
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Sí, guardar',
                    cancelButtonText: 'No',
                    confirmButtonColor: '#6E17A5'

                });
                if (result.isConfirmed) {

                    // Validar el formulario antes de enviarlo
                    const validationErrors = this.validateForm();

                    // Si hay errores de validación, mostrarlos en un único Swal y no enviar el formulario
                    if (Object.keys(validationErrors).length > 0) {
                        const errorMessages = Object.values(validationErrors).join('<br>');
                        Swal.fire({
                            icon: 'error',
                            title: 'Errores de validación',
                            html: '<div class="swal-subtitle"><b>Los siguientes campos son requeridos:</b></div><br>' + errorMessages,
                            confirmButtonColor: '#6E17A5'
                        });
                        return;
                    }

                    const update = await this.upDateUserAdminCompanyId(this.formData);
                    EventBus.$emit('reload-update-usersAdminId', update.nombre);
                    if (!update) {

                        return Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Debes diligenciar los campos'
                        })

                    }

                } else {

                    Swal.fire({
                        position: 'top-end',
                        icon: 'info',
                        title: 'La acción ha sido cancelada.',
                        showConfirmButton: false,
                        timer: 2500
                    });
                }

            } catch (error) {
                console.error("Fallo al actualizar", this.formData)
            }

        },

        formatIdentificationNumber() {
            // Eliminar puntos y espacios del número de identificación actual
            let number = this.formData.identificationNumber.replace(/[^\d]/g, '');

            // Formatear el número con puntos de unidades, decenas, centenas, etc.
            let formattedNumber = '';
            while (number.length > 0) {
                // Agregar los últimos tres dígitos al principio del número formateado
                formattedNumber = number.slice(-3) + formattedNumber;

                // Quitar los últimos tres dígitos del número
                number = number.slice(0, -3);

                // Si todavía quedan dígitos, agregar un punto al principio del número formateado
                if (number.length > 0) {
                    formattedNumber = '.' + formattedNumber;
                }
            }

            // Asignar el número formateado de vuelta al campo de texto
            this.formData.identificationNumber = formattedNumber;
        },

        validateForm() {
            this.showErrorMessages = true;

            const errors = {};

            if (!this.formData.firstName || !this.formData.firstName.trim() || this.formData.firstName.length > 50) {
                errors.firstName = 'Primer Nombre';
            }

            if (this.formData.middleName && !/\S(?:.*\S)?/.test(this.formData.middleName)) {
                errors.middleName = 'Segundo Nombre no debe contener espacios en blanco';
            }

            if (!this.formData.lastName || !this.formData.lastName.trim() || this.formData.lastName.length > 50) {
                errors.lastName = 'Primer Apellido';
            }

            if (this.formData.secondLastName && !/\S(?:.*\S)?/.test(this.formData.secondLastName)) {
                errors.secondLastName = 'Segundo Apellido no debe contener espacios en blanco';
            }

            if (!this.formData.identificationType) {
                errors.identificationType = 'Tipo Identificación';
            }

            if (!this.formData.emailAddress || !correoRegex.test(this.formData.emailAddress) || this.formData.emailAddress.length > 200) {
                errors.emailAddress = 'Correo';
            }

            if (!this.formData.genderId) {
                errors.genderId = 'Género';
            }

            if (!this.formData.identificationNumber || !this.formData.identificationNumber.trim() || this.formData.identificationNumber.length > 19) {
                errors.identificationNumber = 'Número Identificación';
            }

            if (!this.formData.nameRole) {
                errors.nameRole = 'Rol';
            }

            if (!this.formData.countryPhoneCodeId) {
                errors.countryPhoneCodeId = 'Indicativo es requerido';
            }

            if (!this.formData.cellPhoneNumber || !this.formData.cellPhoneNumber.trim() || this.formData.cellPhoneNumber.length !== 10) {
                errors.cellPhoneNumber = 'Contacto WhatsApp';
            }

            return errors;
        },
    },

};

</script>


<style lang="css" scoped>
/* Css input imagen*/

.col-md-7 {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 230px;
}

.detailsUserAdminCompany {
    display: flex;
    gap: 50px;
    flex-direction: row;
    justify-content: center;
}

.custom-row {
    display: flex;
    gap: 50px;
    flex-direction: row;
    justify-content: center;
}

.custom-col {
    padding-left: 5px;
    padding-right: 5px;
}

/*Resposive*/
@media screen and (max-width: 912px) {
    .col-md-7 {
        gap: 40px;
    }
}

@media screen and (max-width: 820px) {
    .col-md-7 {
        gap: 40px;
    }
}

@media screen and (max-width: 768px) {
    .col-md-7 {
        gap: 40px;
    }
}

@media screen and (max-width: 425px) {
    .col-md-7 {
        gap: 10px;
        display: flex;
        flex-direction: column-reverse;
    }

    .botones-container {
        position: fixed;
        bottom: 0;
        right: 0;
        z-index: 999;
    }

    .boton-derecha {
        position: fixed;
        bottom: 0;
        right: 0;
    }
}
</style>